import { cn } from "@/lib/utils";

type Props = {
  className?: string;
}

function ValueSkeleton(props: Props) {
  return (
    <div
      className={cn(props.className, "flex w-full flex-1 h-6.25 p-1 mf-skeleton-base")}
    />
  );
}

export default ValueSkeleton;
